import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AdditionalHttpOpts } from '@common-modules/cache/http-cache/additional-http-options';
import { GetCacheOpts, HttpCacheClient } from '@common-modules/cache/http-cache/http-cache.client';
import { BASE_API_URL } from './generated-client.token';

@Injectable()
export abstract class GeneratedClientManagerService {
  protected httpClient = inject(HttpClient);
  protected baseUrl: string = inject(BASE_API_URL);
  private _httpCacheClient = inject(HttpCacheClient);

  constructor() {}

  buildHttpContext(
    opts: GetCacheOpts = { avoid: true },
    addHttpOptions = new AdditionalHttpOpts({})
  ): HttpContext {
    const { context } = this._httpCacheClient.getConfig(opts, addHttpOptions);
    // TODO: adapt headers to context
    return context;
  }
}
